import { atom } from 'jotai'

import { IntegrationServices } from '@sequencehq/api'

import {
  RevenueClassification,
  RevenueRecognitionMethod
} from 'common/types/revenueRecognition.types'
import { ServicePeriodField } from '../../common/fields'
import {
  createFieldAtom,
  createRevRecDependentFieldAtom
} from '../../common/atoms'

export type FormState = {
  title: string
  servicePeriod: ServicePeriodField
  descriptionEnabled: boolean
  description: string
  taxCategoryId: string
  revenueRecognitionMethod: RevenueRecognitionMethod | undefined
  revenueClassification: RevenueClassification | undefined
  externalIds: Array<{ key: IntegrationServices; value: string }>
  /**
   * Changes to ledgers are manually applied to all line items within a group.
   * If these values are different between line items, don't allow the user to change them here.
   */
  externalIdsEditable: boolean
}

export const INITIAL_STATE: FormState = {
  title: '',
  servicePeriod: undefined,
  descriptionEnabled: false,
  description: '',
  taxCategoryId: '',
  revenueRecognitionMethod: undefined,
  revenueClassification: undefined,
  externalIds: [],
  externalIdsEditable: true
}

export const formStateAtom = atom<FormState>(INITIAL_STATE)

export const titleAtom = createFieldAtom(formStateAtom, 'title')
export const descriptionEnabledAtom = createFieldAtom(
  formStateAtom,
  'descriptionEnabled'
)
export const descriptionAtom = createFieldAtom(formStateAtom, 'description')
export const taxCategoryIdAtom = createFieldAtom(formStateAtom, 'taxCategoryId')
export const revenueRecognitionMethodAtom = createFieldAtom(
  formStateAtom,
  'revenueRecognitionMethod'
)
export const externalIdsAtom = createFieldAtom(formStateAtom, 'externalIds')
export const externalIdsEditableAtom = atom(
  get => get(formStateAtom).externalIdsEditable
)

export const servicePeriodAtom = createRevRecDependentFieldAtom(
  formStateAtom,
  'servicePeriod'
)
export const revenueClassificationAtom = createRevRecDependentFieldAtom(
  formStateAtom,
  'revenueClassification'
)
